module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/time-7a98938406aa760de9edce6e098f3d0e.svg";